module.exports = __webpack_public_path__ + "img/Kelloggs.0d334156.jpg";